module.exports = __webpack_public_path__ + "static/media/banner_mclaren_mid.f2e934e3.png";